import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class PreventReplayAttackInterceptor implements HttpInterceptor {
  private async sha256Hex(message: string): Promise<string> {
    const encoder = new TextEncoder();

    const data = encoder.encode(message);

    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const nonce = uuidv4();
    const timestamp = Math.floor(Date.now() / 1000).toString();

    const cloned = req.clone({
      setHeaders: {
        'X-Nonce': nonce,
        'X-Timestamp': timestamp,
      },
    });

    return next.handle(cloned);
  }
}
